<template>
    <v-container fluid class="bg-main">
        <v-layout row>
            <v-flex xs12>

                <v-card>
                    <v-card-title>
                        Danh Sách Vip:
                        <v-spacer></v-spacer>

                        <div class="float-right div-icon-action">
                            <v-icon @click="print" >mdi-printer</v-icon>
                        </div>
                        <div class="float-right div-icon-action ml-0">
                            <export-excel  :data   = "desserts">
                                <v-icon>mdi-file-export</v-icon>
                            </export-excel>
                        </div>
                    </v-card-title>
                    <div id="fb-post-activity-log">
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="elevation-1"
                        >
                            <template v-slot:item.uid = "{item}">
                                <v-layout row>
                                    <a class="a-post-link" :href="item.link" target="_blank">{{ item.uid }}</a>
                                </v-layout>
                            </template>
                            <template v-slot:item.prices = "{item}">
                                <span>{{ item.prices | currency_init }}</span>
                            </template>
                            <!--Status-->
                            <template v-slot:item.status="{ item }">
                                <v-chip v-if="item.status == 1" color="orange" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-sync</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                                <v-chip v-if="item.status == 2" color="success" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-check</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                                <v-chip v-if="item.status == 3" color="secondary" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-close-circle</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                                <v-chip v-if="item.status == 4" color="danger" dark>
                                    <v-avatar left>
                                        <v-icon>mdi-cancel</v-icon>
                                    </v-avatar>
                                    {{ item.status_name }}
                                </v-chip>
                            </template>
                            <!--Status-->

                            <!--Icon cancel-->
                            <!-- <template v-slot:item.action="{item}">
                                <v-icon color="red" @click="checkJobDone(item.id)" v-if="item.status === 1">
                                    mdi-check
                                </v-icon>
                                <v-icon color="red" @click="fetchDataFromApi(item.id)" v-if="item.status === 1">
                                    mdi-sync
                                </v-icon>
                                <v-icon color="red" @click="editJob(item.id)" v-if="item.status === 1">
                                    mdi-pencil
                                </v-icon>
                            </template> -->
                            <!--Icon cancel-->
                        </v-data-table>
                    </div>

                    <div id="fb-post-activity-log-print">
                        <v-data-table
                                :headers="headers"
                                :items="desserts"
                                :options.sync="options"
                                :server-items-length="totalDesserts"
                                :loading="loading"
                                class="elevation-1"
                                disable-pagination
                                hide-default-footer
                        >

                        </v-data-table>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {
        VIP_FACE_LIST,
        FB_POST_GET_LIST_REACTION,
        FB_POST_GET_LIST_SEEDING,
        VIP_CANCEL_ORDER
    } from "../../store/actions.type";
    import Swal from "sweetalert2";
    // import Swal from 'sweetalert2';

    export default {
        data () {
            return {
                dialog: false,
                totalDesserts: 0,
                desserts: [],
                loading: true,
                options: {},
                headers: [
                    { text: '#', value: 'id', align: "center"},
                    { text: 'Username', value: 'username', align: "center"},
                    { text: 'Uid', value: 'uid'},
                    { text: 'Name', value: 'name', align: "center" },
                    { text: 'Min Like', value: 'min_like', align: "center"  },
                    { text: 'Max Like', value: 'max_like', align: "center"  },
                    { text: 'Số Ngày', value: 'days', align: "center"  },
                    { text: 'Tổng Tiền', value: 'prices', align: "center"  },
                    { text: 'Hết Hạn', value: 'end_at', align: "center"  },
                    { text: 'Khởi Tạo', value: 'start_at', align: "center"  },
                    { text: 'Ghi Chú', value: 'note', align: "center"  },
                    // { text: 'Thao Tác', value: '11', align: "center"  },
                    {text: 'Trạng thái', value: 'status', align: "center"},
                    // {text: 'Hành động', value: 'action', align: "center", width: '300px'}
                ],
                listSeedingApi: [],
                listReaction: []
            }
        },
        watch: {
            options: {
                handler () {
                    this.getDataFromApi()
                        .then(data => {
                            this.desserts = data.items
                            this.totalDesserts = data.total
                        })
                },
                deep: true,
            },
        },
        mounted () {
            this.getDataFromApi()
                .then(data => {
                    this.desserts = data.items,
                        this.totalDesserts = data.total
                });
        },
        methods: {
            checkJobDone(id) {
                this.desserts.forEach(item => {
                    if (item.id === id) {
                        this.coin_cancel_order = item.coin_cancel_order;
                    }
                })
                // Swal.fire({
                //     title: 'Bạn có thực sự muốn hoàn thành job?',
                //     text: `Sau khi hoàn thành bạn sẽ có thể tạo thêm job mới!`,
                //     icon: 'success',
                //     showCancelButton: true,
                //     confirmButtonColor: '#d33',
                //     cancelButtonColor: '#3085d6',
                //     confirmButtonText: 'Hoàn thành job',
                //     cancelButtonText: 'Quay lại'
                // }).then(async (result) => {
                //     if (result.value) {
                //         await this.$store.dispatch(TIKTOK_JOB_SUCCESS_ORDER, id);
                //         let desserts = [...this.desserts];
                //         desserts.forEach(item => {
                //             if (item.id === id) {
                //                 item.status = 2;
                //                 item.status_name = "Thành công";
                //             }
                //         });
                //         this.desserts = [...desserts];
                //         Swal.fire(
                //             'Đã hoàn thành!',
                //             'Job của bạn đã được hoàn thành',
                //             'success'
                //         )
                //     }
                // })
            },

            editJob(id) {
                this.desserts.forEach(item => {
                    if (item.id === id) {
                        this.num_seeding_post = item.num_seeding_need;
                    }
                });
                Swal.fire({
                    title: 'Chỉnh sửa số lượng tăng',
                    input: 'text',
                    showCancelButton: true,
                    inputValue: this.num_seeding_post,
                }).then(
                    result => {
                        if (result.value < this.num_seeding_post) {
                            Swal.fire({
                                type: 'error',
                                icon: 'warning',
                                text: "Bạn không được nhập số lượng seeding thấp hơn số lượng ban đầu"
                            })
                        } else {
                            let desserts = [...this.desserts];
                            desserts.forEach(item => {
                                if (item.id === id) {
                                    item.num_seeding_need = result.value;
                                }
                            });
                            this.desserts = [...desserts];
                            Swal.fire({
                                type: 'success',
                                icon: 'success',
                                text: "Bạn đã thay đổi thành công số lượng ban đầu"
                            })
                        }
                    }
                );
            },
            fetchDataFromApi(id) {
                this.$store.dispatch(VIP_CANCEL_ORDER, id).then(resp => {
                    let desserts = [...this.desserts];
                    desserts.forEach(item => {
                        if (item.id === id) {
                            item.num_seeding_gain = resp.num_seeding_gain;
                        }
                    });
                    this.desserts = [...desserts];
                });
            },
            async getDataFromApi () {
                this.listSeedingApi =  await this.$store.dispatch(FB_POST_GET_LIST_SEEDING);
                this.listReaction = await this.$store.dispatch(FB_POST_GET_LIST_REACTION);

                this.loading = true
                const { sortBy, sortDesc, page, itemsPerPage } = this.options

                let items =  await this.$store.dispatch(VIP_FACE_LIST, {"api_route": "facebook-vip/vip-like-count" });
                const total = items.length

                if (sortBy.length === 1 && sortDesc.length === 1) {
                    items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }

                if (itemsPerPage > 0) {
                    items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                }
                this.loading = false;
                return {items,total};

            },
            print() {
                this.$htmlToPaper("fb-post-activity-log-print");
            },
            //cancel job
            async cancelOrder(id, cancel_order_coin) {
                Swal.fire({
                    title: 'Bạn có thực sự muốn hủy?',
                    text: `Sau khi hủy bạn sẽ được hoàn lại số tiền tương ứng với số lượng chưa được tăng và trừ thêm ${cancel_order_coin} coin phí để tránh Spam !`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Hủy job',
                    cancelButtonText: 'Quay lại'
                }).then(async (result) => {
                    if (result.value) {
                        await this.$store.dispatch(VIP_CANCEL_ORDER, id);
                        let desserts = [...this.desserts];
                        desserts.forEach(item => {
                            if (item.id === id) {
                                item.status = 4;
                                item.status_name = "Hủy bỏ";
                            }
                        });
                        this.desserts = [...desserts];
                        Swal.fire(
                            'Đã hủy!',
                            'Job của bạn đã hủy thành công',
                            'success'
                        )
                    }
                })
            }
        },
    }
</script>
<style lang="scss">
    .div-icon-action{
        i {
            cursor: pointer;
        }
    }
    .a-post-link {
        text-decoration: none;
    }
    #fb-post-activity-log-print {
        display: none;
    }
</style>
